

























































































import {Component, Prop, Vue} from 'vue-property-decorator'
import TextField from "@/components/UI/TextField.vue";
import DeliousItemsStore from "@/_common/api/store/modules/DeliousItemsStore";
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import CategoryItemsStore from "@/_common/api/store/modules/CategoryItemsStore";
import {Util} from "@/_global/utils";
import PluClassesStore from '@/store/modules/PluClassesStore';

@Component({
    components: {
        TextField,
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
    },
})
export default class AddCategoryItemDialog extends Vue {
    private searchWord: string = "";
    private searchLClassNo: number = -1;
    private searchMClassNo: number = -1;
    private searchSClassNo: number = -1;
    private selectedItemId: number = -1;
    private selectedItems: any = [];
    private categoryItems: any = [];

    get filteredItems(): Delious.ItemBase[] {
        let allItems: Delious.ItemBase[] = DeliousItemsStore.all.list as Delious.ItemBase[];
        let searchWordEscape = Util.regExpEscape(this.searchWord);

        if (searchWordEscape)
            allItems = allItems.filter(v => v.item_name.match(searchWordEscape) || v.plu_no.toString().match(searchWordEscape));

        if (this.searchLClassNo > 0)
            allItems = allItems.filter(v => v.l_class_no == this.searchLClassNo);

        if (this.searchMClassNo > 0)
            allItems = allItems.filter(v => v.m_class_no == this.searchMClassNo);

        if (this.searchSClassNo > 0)
            allItems = allItems.filter(v => v.s_class_no == this.searchSClassNo);

        return allItems;
    }

    get lClassItems(): Delious.PluClass[] {
        const lClass = PluClassesStore.all_l.list || {};

        return lClass;
    }

    get mClassItems(): Delious.PluClass[] {
        const mClass = PluClassesStore.all_m.list || {};

        return mClass;
    }

    get sClassItems(): Delious.PluClass[] {
        const sClass = PluClassesStore.all_s.list || {};

        return sClass;
    }

    private onInput(e: InputEvent): void {
        this.searchWord = e.data || "";
    }

    private onClickItem(itemId: number, force: boolean=false): void {
        this.selectedItemId = this.selectedItemId != itemId ? itemId : -1;
        let index = -1;
        if(!this.selectedItems.length){
            this. selectedItems.push(itemId);
        }else {
            index = this.selectedItems.indexOf(itemId);
            if (index >= 0) {
                this.selectedItems.splice(index, 1);
                if(force){
                    this.selectedItems.push(itemId);
                }
            } else {
                this.selectedItems.push(itemId);
            }
        }
    }

    private onClickShift(itemId: number=0) : void{
        const selectionObject = window.getSelection(); // 選択範囲(selectionオブジェクト)の取得
        if(selectionObject) {
            const selectionDOM = selectionObject.getRangeAt(0).cloneContents();
            const resultItemId = selectionDOM.querySelectorAll('div.result-item-id');
            let iId: number;
            let fl = false;
            for(let i = 0, l = resultItemId.length; l > i; i++){
                iId = Number(resultItemId[i].innerHTML);
                this.onClickItem(iId, true);
                fl = iId == itemId?true:fl;
            }
            // 下から上に範囲選択する場合、IDのdivが選択範囲に含まれなくなるケースがあるため
            if(!fl){
                this.onClickItem(itemId);
            }
        }
    }

    private addCategoryItems() {
        let tmpId: number = Util.getTempId(CategoryItemsStore.all);
        this.selectedItems = this.selectedItems.sort(function(a: number, b: number){
            if(a < b) return -1;
            if(a > b) return 1;
            return 0;
        });
        this.selectedItems.forEach((value:any, i:any) => {
            if (value) {
                const categoryId: number = Number(this.$route.params.categoryId);
                this.categoryItems.push({
                    id: tmpId,
                    category_id: categoryId,
                    item_id: value,
                    visible: true
                });
                tmpId++;
            }
         })
        this.selectedItems.splice(0);
    }

    private onClickAllItem() {
        let filteredItems: Delious.ItemBase[] = this.filteredItems;
        let itemId: number;
        for (let i = 0; i < filteredItems.length; i++) {
            itemId = Number(filteredItems[i].plu_no);
            if (this.selectedItems.indexOf(itemId) === -1) {
                this.selectedItems.push(itemId);
            }
        }
    }

    get newCategoryItem():  CMS.CategoryItem[] {
        this.addCategoryItems();
        return this.categoryItems;
    }
}
